module.exports = __webpack_public_path__ + "media/images/delivery-truck 1-0afee3b6.svg";